/* eslint-disable */
import React, { useEffect, useState } from "react";
import { api_url } from "../../Constants/web_services";
import { useSelector } from "react-redux";
import { selectUserData } from "../../Redux/UserSlice";
import { DatePicker } from "antd";
import moment from "moment";

import "../../Assets/css/custom.css";
import Swal from "sweetalert2";
const { RangePicker } = DatePicker;

const ServiceLists = ({ company, serviceInfo }) => {
    const [companyData] = useState(company);
    const [serviceData] = useState(serviceInfo);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    // const isSignedIn = useSelector(selectSignedIn);
    const userData = useSelector(selectUserData);
    const [durationDays, setDurationDays] = useState(0);
    const [startDuration, setStartDuration] = useState('');
    const [endDuration, setEndDuration] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [minDayDuration, setMinDayDuration] = useState('');
    const [service, setService] = useState();
    // const [amount, setAmount] = useState('')
    useEffect(() => {
        setService(serviceData);
    }, [serviceData]);



    // if (!companyData?.services || companyData.services.length === 0) {
    //     return "<h1>NO SERVICES</h1>";
    // }

    const disabledDate = (current, minimumDays) => {
        if (!startDate || !endDate || minimumDays === 0) {
            return current.isBefore(moment().add(1, 'day').startOf("day"));
        } else {

            const selectedStartDate = new Date(startDate);
            const startDateFinal = moment(selectedStartDate).format('L');

            const selectedEndDate = new Date(endDate);
            const endDateFinal = moment(selectedEndDate).format('L');

            const estDate = moment(selectedStartDate).add(minimumDays, "day").add(0, 'day').endOf("day").format('L');

            setMinDayDuration(minimumDays);
            setStartDuration(moment(startDateFinal).format('YYYY/DD/MM, h:mm:ss'));
            setEndDuration(moment(endDateFinal).format('YYYY/DD/MM, h:mm:ss'));

            setDeliveryDate(estDate);
            return (
                current.isBefore(moment().add(1, 'day').startOf("day")) || // Check if current date is before start of today
                (current.isBefore(startDateFinal) && current.isAfter(estDate)) // Check if current date is between start date and estimated delivery date
            );

        }
    };



    const handleTime = (date, duration) => {

        if (duration[0] !== '' && duration[1] !== '') {
            const start = new Date(duration[0]);
            const end = new Date(duration[1]);
            const differenceInMilliseconds = Math.abs(end - start);
            const differenceInDays = Math.ceil(
                differenceInMilliseconds / (1000 * 60 * 60 * 24)
            );
            const durationInDays = differenceInDays === 0 ? 1 : differenceInDays;
            setStartDate(date[0]);
            setEndDate(date[1]);
            setDurationDays(durationInDays);
        } else {
            setStartDate('');
            setEndDate('');
            setDurationDays('');

        }
    };

    const handleAvailOffer = (e, serviceId) => {
        e.preventDefault(); // Prevent default form submission behavior
        const formData = new FormData(e.target);
        const amount = parseInt(formData.get('amount'), 10);
        const companyId = companyData?.id;
        setButtonDisabled(true);

        // Ensure that amount is a valid number before proceeding
        if (isNaN(amount)) {
            console.error("Invalid amount");
            setButtonDisabled(false);
            return;
        }

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                company_id: companyId,
                service_id: serviceId,
                amount: amount,
                approval: 0,
                user_id: userData.id,
                start_duration: startDuration,
                end_duration: endDuration,
                duration_days: durationDays,
            }),
        };

        fetch(api_url + "/api/getservice", requestOptions)
            .then((response) => {
                if (response.ok) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Your offer has been successfully submitted.'
                    });
                    console.log("API request was successful");
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to submit your offer. Please try again later.'
                    });
                    console.error("API request failed");
                }
                setButtonDisabled(true);
            })
            .catch((error) => {
                console.error("API request error:", error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while processing your request. Please try again later.'
                });
                setButtonDisabled(false);
            });
    };

    const handleSubmit = (e, serviceId) => {
        e.preventDefault(); // Prevent the default form submission behavior

        handleAvailOffer(e, serviceId); // Pass the event and serviceId
    };
    const handleDisableButton = (e, minimumDays) => {
        e.preventDefault();

        Swal.fire({
            title: 'Make requirements first',
            html: `choose dates according to minimum <strong>${minimumDays}</strong> working days`,
            icon: 'warning',
            confirmButtonText: `<i className="fa fa-thumbs-up"></i> Great!`,

        });
    };

    return (
        <>
            {service && (

                <div >
                    <ul className="sf-provi-service-list ps-0 mt-2 ">
                        <li className="sf-provi-service-box ">
                            <div className="sf-provi-service-top row justify-content-between">
                                <div className="sf-provi-service-left col-md-3 ml-0" >
                                    <h4 className="sf-provi-service-ttle fw-700 s-18 text-drk-primary">
                                        <span className="sf-provi-toggle-btn">:</span>{" "}
                                        {service?.service_name}
                                        <span>Offer</span>
                                    </h4>
                                    <div className="sf-provi-service-price fw-600">
                                        ${" "}
                                        <span className="fw-700 ml-1">
                                            {service?.service_price}
                                        </span>
                                    </div>
                                    <div className="sf-provi-service-bottom text-warning fw-600 ">
                                        <i className="fa fas fa-stopwatch-20 mr-1"></i>{" "}
                                        minimum
                                        <span className="fw-700 ml-1 text-danger">
                                            {service?.minimum_days}{" "}
                                        </span>{" "}
                                        working days
                                    </div>
                                </div>
                                <div className="sf-provi-service-hour col-md-6 ml-0">
                                    <i className="fa fa-calendar ml-3 text-drk-primary">
                                        {" "}
                                        &nbsp; &nbsp; Select Date :
                                    </i>
                                    <p className="ml-3 text-warning fw-600">Your <span className="text-danger">minimum</span>  delivery date will must be :
                                        <span className="text-danger fw-700 ">{" "}
                                            {startDate ?

                                                moment(deliveryDate).format("LL") : <></>}


                                        </span>
                                    </p>
                                    <div className="row mt-3 justify-content-evenly">
                                        <div className="col-md-7">
                                            <RangePicker
                                                onChange={handleTime}
                                                allowEmpty={[true, true]}
                                                disabledDate={(current) =>
                                                    disabledDate(current, service?.minimum_days)
                                                }
                                            />
                                        </div>

                                        <div className="col-md-5 font-size-12 text-uppercase">
                                            {" "}
                                            After Payment Confirmation Estimated time: <br />
                                            <span className="text-primary text-capitalize">
                                                {Number.isNaN(durationDays) ||
                                                    durationDays === 0
                                                    ? "not specified"
                                                    : `${durationDays} day`}

                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2 justify-content-center mt-5">


                                    {
                                        (minDayDuration && durationDays && minDayDuration === durationDays || minDayDuration && durationDays && durationDays > minDayDuration) ?
                                            <form onSubmit={(e) => handleAvailOffer(e, service?.id)}>
                                                <input type="hidden" name="amount" value={service?.service_price} />
                                                <button
                                                    type="submit"
                                                    className="site-button btn-schedules fw-700 p-4"
                                                    disabled={buttonDisabled}
                                                >
                                                    Avail Offer
                                                </button>
                                            </form>
                                            : <form style={{ opacity: '.5' }}>

                                                <button
                                                    type="button" // Change type to button to prevent form submission by default
                                                    className="site-button btn-schedules disabled fw-700 p-4"
                                                    onClick={(e) => handleDisableButton(e, service?.minimum_days)}// Prevent default behavior
                                                >
                                                    Avail Offer
                                                </button>
                                            </form>
                                    }
                                </div>
                            </div>

                            <div className="sf-provi-service-bottom mt-2">
                                <div className="sf-provi-descriptio">
                                    {service?.service_description}
                                </div>

                                <div className="sf-provi-descriptio mt-1  fw-bolder">
                                    "If there is a delay in your payment, the allotted
                                    time will be automatically extended."
                                </div>
                            </div>
                        </li>

                        {/* <li className="sf-provi-service-box">
            <div className="sf-provi-service-top">
                <div className="sf-provi-service-left">
                    <h4 className="sf-provi-service-ttle fw-700 s-18 text-drk-primary">
                        <span className="sf-provi-toggle-btn ">+</span> 3 bedroom or a
                        house <span>Offer</span>
                    </h4>
                    <div className="sf-provi-service-price">$ 10.00/Hour</div>
                </div>
                <div className="sf-provi-service-right">
                    <div className="sf-provi-service-count">
                        <input id="demo2" type="text" defaultValue={55} name="demo1" />
                    </div>
                    <button className="site-button btn-schedules">Schedule</button>
                </div>
            </div>
            <div className="sf-provi-service-bottom">
                <div className="sf-provi-descriptio">
                    Many serives have a wide spectrum of expertise in web solutions
                    within these industries, giving us the necessary skills and
                    knowledge.
                </div>
            </div>
        </li> */}
                    </ul>
                </div>

            )}
        </>
    );
}


export default ServiceLists;
